import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function UploadOtherWikiBreadcrumbWrapper() {
  useBreadcrumb('routes/upload/other', 'Other Wiki Articles');
  return <Outlet />;
}
